import { Injectable } from '@angular/core';
import { Guid } from "typescript-guid";
import { ProjectData } from '../model/projectData';

@Injectable({
  providedIn: 'root'
})
export class CurrentService {

  styleId:number;
  modelId:number;
  layoutRef:string;
  ovenConfigurationRef:string;
  furnitureConfiguration:string;

  project: ProjectData;

  sessionId: string;
  constructor() {
    this.reset();
  }

  initSession() {
    this.sessionId = Guid.create().toString();
  }

  reset() {
    this.project = null;
    this.styleId = -1;
    this.modelId = -1;
    this.layoutRef = null;
    this.ovenConfigurationRef = null;
    this.furnitureConfiguration = null;
  }
}
